import { createComponent } from '@carvana/merch-components';

export const Tile = createComponent('div', {
  className:
    'w-[240px] rounded-md border border-grey-2 bg-white text-blue-6 m:w-[300px]'
});

export const TileImageSection = createComponent('section', {
  className:
    'relative h-[130px] overflow-hidden rounded-[8px_8px_0_0] m:h-[169px]'
});

export const TileInfoSection = createComponent('section', {
  className: 'p-16'
});

export const YearMakeModel = createComponent('p', {
  className: 'overflow-hidden text-ellipsis whitespace-nowrap tl-header-xs'
});

export const TrimMileage = createComponent('p', {
  className: 'mb-16 flex flex-row text-grey-5 tl-body-s'
});

export const Trim = createComponent('span', {
  className:
    'overflow-hidden text-ellipsis whitespace-nowrap s:max-w-[60%] m:max-w-[75%]'
});

export const FavoriteWrapper = createComponent('div', {
  className: 'absolute right-0 z-1 flex h-44 w-44 items-center justify-center'
});
